module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/gold_bg.2b23ea20.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/gold_bg.png
// module id = 2858
// module chunks = 11